export default "__VITE_ASSET__COqxmEGK__"